import { ParameterModule } from '../../Components/Suggestion/parameterSearch/ParameterSearch'
import {
  CreateMastersData,
  CreateSegmentRequestModal,
  CreateUserRequestModal,
  SegmentCRUDAPIDefinitionModal,
  UserCRUDAPIDefinitionModal,
  ViewMastersAPIDefinition,
  auditLogsApiModal,
  createRoleReqData,
  parameterCRUDAPIDefinitionModal,
  parameterStatusChangeDefinitionModal,
  roleCRUDAPIDefinitionModal,
  roleStatusChangeDefinitionModal,
  userStatusChangeDefinitionModal,
  viewParameterAPIDefinationModal,
  viewRoleAPIDefinationModal,
} from '../../Models'
import { categoryListApiDefinitionModal } from '../../Models/AssetDefinitionModal'
import { attributeCRUDAPIDefinitionModal } from '../../Models/AttributeModal'
import { moduleType } from '../../Models/CommonListHeadingModal'
import { WidgetCRUDAPIDefinitionModal } from '../../Store/Slice/manage-widget.slice'
import { CONSTANTS } from '../Constant'

const { ADDITIONAL_PARAMETER, DETAIL, UPDATE, CONFIG } = CONSTANTS.API_URL
const { GET, PATCH } = CONSTANTS.HTTP_METHOD

export const AUTH_MANAGEMENT = {
  VALIDATE_CODE_LOCAL: (code: string) => ({
    url: '/sso/login',
    method: CONSTANTS.HTTP_METHOD.GET,
    params: {
      code: code,
    },
    headers: {
      'Dev-Mode': true,
    },
  }),
  VALIDATE_CODE: (code: string) => ({
    url: '/sso/login',
    method: CONSTANTS.HTTP_METHOD.GET,
    params: {
      code: code,
    },
  }),
  REFRESH_TOKEN: () => ({
    url: '/session/refreshToken',
    method: CONSTANTS.HTTP_METHOD.GET,
    params: {},
  }),
  RELEASE_INFO: () => ({
    url: '/application/build-version/get',
    method: CONSTANTS.HTTP_METHOD.GET,
    params: {},
  }),
  LOGOUT: () => ({
    url: '/session/logout',
    method: CONSTANTS.HTTP_METHOD.GET,
    params: {},
  }),
}
export const SYSTEM_CONFIG_APIS = {
  LIST_MASTERS: (key: string) =>
    ({
      url: '/system-configurations/list?keyName=' + key,
      method: 'get',
      data: {},
    }) as categoryListApiDefinitionModal,
}
export const CONFIG_APIS = {
  GET_ASSET_TYPES: () =>
    ({
      url: `/${CONFIG}/assetTypes`,
      method: GET,
      data: {},
    }) as viewRoleAPIDefinationModal,
  GET_TYPE_AND_LAYOUT: (moduleType: string) =>
    ({
      url: `/${CONFIG}/typeAndLayouts?module=${moduleType}`,
      method: GET,
      data: {},
    }) as any,
}
export const ROLE_MANAGEMENT_CRUD = {
  CREATE_ROLE: (data: createRoleReqData) =>
    ({
      url: '/userRole/add',
      method: CONSTANTS.HTTP_METHOD.POST,
      data: data,
    }) as roleCRUDAPIDefinitionModal,
  VIEW_ROLE: (id: string) =>
    ({
      url: '/userRole/detail/' + id,
      method: CONSTANTS.HTTP_METHOD.GET,
      data: {},
    }) as viewRoleAPIDefinationModal,
  PERMISSIONS_LIST: () =>
    ({
      url: '/config/permissions',
      method: CONSTANTS.HTTP_METHOD.GET,
      data: {},
    }) as viewRoleAPIDefinationModal,
  LIST_ROLE: (data: string) =>
    ({
      url: '/userRole/list' + '?' + data,
      method: CONSTANTS.HTTP_METHOD.GET,
      data: {},
    }) as viewRoleAPIDefinationModal,
  GET_ROLES: () =>
    ({
      url: '/userrole/list',
      method: 'get',
      data: {},
    }) as viewRoleAPIDefinationModal,
  EDIT_ROLE: (data: createRoleReqData) =>
    ({
      url: '/userRole/update',
      method: CONSTANTS.HTTP_METHOD.PATCH,
      data: data,
    }) as roleCRUDAPIDefinitionModal,
  DELETE_ROLE: (id: string) =>
    ({
      url: '/userRole/delete/' + id,
      method: CONSTANTS.HTTP_METHOD.DELETE,
      data: {},
    }) as roleCRUDAPIDefinitionModal,
  CHANGE_STATUS: (data: { status: string; roleId: string }) =>
    ({
      url: '/userRole/updateRoleStatus',
      method: CONSTANTS.HTTP_METHOD.PATCH,
      data: data,
    }) as roleStatusChangeDefinitionModal,
}

export const USER_MANAGEMENT_CRUD = {
  CREATE_USER: (data: CreateUserRequestModal) =>
    ({
      url: '/user/add',
      method: CONSTANTS.HTTP_METHOD.POST,
      data: data,
    }) as UserCRUDAPIDefinitionModal,
  UPDATE_USER: (data: CreateUserRequestModal) =>
    ({
      url: '/user/update',
      method: 'patch',
      data: data,
    }) as UserCRUDAPIDefinitionModal,
  VIEW_USER: (id: string) =>
    ({
      url: `/user/list?page=1&filterBy=_id&filterValue=${id}&filterCondition=isEqualTo`,
      method: 'get',
      data: {},
    }) as roleCRUDAPIDefinitionModal,
  CHANGE_STATUS: (data: { userId: string; userStatus: string }) =>
    ({
      url: '/user/updateUserStatus',
      method: 'patch',
      data: data,
    }) as userStatusChangeDefinitionModal,
  LIST_USER: (data: string) =>
    ({
      url: '/user/list' + '?' + data,
      method: 'get',
      data: {},
    }) as viewRoleAPIDefinationModal,
}
export const PARAMETER_MANAGEMENT_CRUD = {
  CREATE_PARAMETER: (data: any) =>
    ({
      url: '/parameter-repository/add',
      method: CONSTANTS.HTTP_METHOD.POST,
      data: data,
    }) as parameterCRUDAPIDefinitionModal,
  CLONE_PARAMETER: (data: any, apiMidpoint: string | undefined) =>
    ({
      url: `/${apiMidpoint}/clone`,
      method: CONSTANTS.HTTP_METHOD.POST,
      data: data,
    }) as parameterCRUDAPIDefinitionModal,
  UPDATE_PARAMETER: (data: any) =>
    ({
      url: '/parameter-repository/update',
      method: CONSTANTS.HTTP_METHOD.PUT,
      data: data,
    }) as parameterCRUDAPIDefinitionModal,

  // VIEW_PARAMETER: (id: string) =>
  //   ({
  //     url: `/parameter-repository/list?page=1&filterBy=_id&filterValue=${id}&filterCondition=isEqualTo`,
  //     method: 'get',
  //     data: {},
  //   }) as viewParameterAPIDefinationModal,
  VIEW_PARAMETER: (id: string) =>
    ({
      url: '/parameter-repository/detail/' + id,
      method: CONSTANTS.HTTP_METHOD.GET,
      data: {},
    }) as viewParameterAPIDefinationModal,

  LIST_PARAMETER: (data: string) =>
    ({
      url: '/parameter-repository/list' + '?' + data,
      //  url: '/parameter-repository/list'+'?'+ 'isComplexType=false',
      method: 'get',
      data: {},
    }) as viewParameterAPIDefinationModal,
  COMPLEX_PARAMETER_LIST: () =>
    ({
      // url: '/parameter-repository/list'+'?'+data,
      url: '/parameter-repository/list' + '?' + 'isComplexType=true',
      method: 'get',
      data: {},
    }) as viewParameterAPIDefinationModal,
  DELETE_PARAMETER: (id: string) =>
    ({
      url: '/parameter-repository/delete/' + id,
      method: CONSTANTS.HTTP_METHOD.DELETE,
      data: {},
    }) as parameterCRUDAPIDefinitionModal,
  PARAMETER_MASTER_LIST: () =>
    ({
      url: '/config/masterlist',
      method: CONSTANTS.HTTP_METHOD.GET,
      data: {},
    }) as viewParameterAPIDefinationModal,
  MASTER_LIST: () =>
    ({
      url: '/parameter-repository/masterlist',
      method: CONSTANTS.HTTP_METHOD.GET,
      data: {},
    }) as viewParameterAPIDefinationModal,
  CHANGE_STATUS: (data: { parameterId: string; status: string }) =>
    ({
      url: '/parameter-repository/updateParameterStatus',
      method: CONSTANTS.HTTP_METHOD.PUT,
      data: data,
    }) as parameterStatusChangeDefinitionModal,
}

export const HOME_PAGE = {
  GET_HOME_PAGE: (data: string) =>
    ({
      url: '/dashboard/detail' + '?' + data,
      method: CONSTANTS.HTTP_METHOD.GET,
      data: {},
    }) as auditLogsApiModal,

  GET_DASHBOARD_PIN_SEARCH_DATA: () => ({
    url: '/save-search/pinnedSearchList',
    method: CONSTANTS.HTTP_METHOD.GET,
    data: {},
  }),
  UNPIN_SAVE_DATA: (id: any) => ({
    url: '/save-search/unpinSaveSearch',
    method: CONSTANTS.HTTP_METHOD.PATCH,
    data: id,
  }),
}
export const HOME = {
  RECENT_ACTIVITY: {
    baseUrl: CONSTANTS.AUDIT_LOGS_BASE_URL,
    url: '/audit-trails/recentActivities',
    method: CONSTANTS.HTTP_METHOD.POST,
    data: {},
  },
}

export const GLOBAL_SEARCH = {
  LIST: (data: any) => ({
    url: '/global-search/list',
    method: CONSTANTS.HTTP_METHOD.POST,
    data: data,
  }),
  ADVANCE_SEARCH: (data: any) =>
    ({
      url: '/global-search/list',
      method: CONSTANTS.HTTP_METHOD.POST,
      data: data,
    }) as attributeCRUDAPIDefinitionModal,
  ADVANCED_SEARCH_DOWNLOAD: (data: any) =>
    ({
      url: '/global-search/download',
      method: CONSTANTS.HTTP_METHOD.POST,
      data: data,
    }) as attributeCRUDAPIDefinitionModal,
}

export const MANAGETIP_APIS_CRUD = {
  GET_TIP: () => ({
    url: '/tooltip/list',
    method: 'get',
    data: {},
  }),

  TIP_UPDATE: (data: any) => ({
    url: '/tooltip/update',
    method: CONSTANTS.HTTP_METHOD.PATCH,
    data: data,
  }),
}

// export const SYSTEM_CONFIG_APIS = {
//   LIST_MASTERS: (key: string) =>
//     ({
//       url: '/attributeRepository/systemConfigurations/list?keyName=' + key,
//       method: 'get',
//       data: {},
//     }) as categoryListApiDefinitionModal,
// }

export const SEGMENT_MANAGEMENT_CRUD = {
  CREATE_SEGMENT: (data: CreateSegmentRequestModal) =>
    ({
      url: '/segment/add',
      method: CONSTANTS.HTTP_METHOD.POST,
      data: data,
    }) as SegmentCRUDAPIDefinitionModal,
  UPDATE_SEGMENT: (data: CreateSegmentRequestModal) =>
    ({
      url: '/segment/update',
      method: 'patch',
      data: data,
    }) as SegmentCRUDAPIDefinitionModal,
  VIEW: (id: string) =>
    ({
      url: `/segment/detail/${id}`,
      method: 'get',
      data: {},
    }) as SegmentCRUDAPIDefinitionModal,
  LIST: (data: any) =>
    ({
      url: '/segment/list',
      method: CONSTANTS.HTTP_METHOD.POST,
      data,
    }) as viewRoleAPIDefinationModal,
  DELETE_SEGMENT: (id: string) =>
    ({
      url: '/segment/delete/' + id,
      method: CONSTANTS.HTTP_METHOD.DELETE,
      data: {},
    }) as SegmentCRUDAPIDefinitionModal,
  DELETE_SEGMENT_CONFIRMATION: (id: string) => ({
    url: '/segment/checkSegmentMapped/' + id,
    method: CONSTANTS.HTTP_METHOD.GET,
    data: {},
  }),
  GET_ALL_SEGMENT_NAME: () =>
    ({
      url: '/segment/getAllSegmentName',
      method: CONSTANTS.HTTP_METHOD.GET,
      data: {},
    }) as SegmentCRUDAPIDefinitionModal,
}

export const MASTERS_MANAGEMENT = {
  MASTER: {
    LIST: () =>
      ({
        url: '/config/masterlist',
        method: 'get',
        data: {},
      }) as ViewMastersAPIDefinition,
  },
  COUNTRIES_CRUD: {
    LIST_COUNTRIES: (data: string) =>
      ({
        url: '/countries/list' + '?' + data,
        method: 'get',
        data: {},
      }) as ViewMastersAPIDefinition,
    UPDATE_COUNTRIES: (data: CreateMastersData) => ({
      url: '/countries/update',
      method: CONSTANTS.HTTP_METHOD.PATCH,
      data,
    }),
    CREATE_COUNTRIES: (data: CreateMastersData) => ({
      url: '/countries/add',
      method: CONSTANTS.HTTP_METHOD.POST,
      data,
    }),
  },
  SEGMENT_MASTER: {
    LIST: (apiMidpoint: string, paramsData: any) =>
      ({
        url: `/master/${apiMidpoint}/list` + '?' + paramsData,
        method: 'get',
        data: {},
      }) as ViewMastersAPIDefinition,

    CREATE: (apiMidpoint: string, data: any) => ({
      url: `/master/${apiMidpoint}/add`,
      method: CONSTANTS.HTTP_METHOD.POST,
      data,
    }),
    UPDATE: (apiMidpoint: string, data: any) => ({
      url: `/master/${apiMidpoint}/update`,
      method: CONSTANTS.HTTP_METHOD.PUT,
      data,
    }),
    LIST_WITHOUT_MASTER: (apiMidpoint: string, paramsData: any) =>
      ({
        url: `/master/${apiMidpoint}/list` + '?' + paramsData,
        method: 'get',
        data: {},
      }) as ViewMastersAPIDefinition,

    CREATE_WITHOUT_MASTER: (apiMidpoint: string, data: any) => ({
      url: `/master/${apiMidpoint}/add`,
      method: CONSTANTS.HTTP_METHOD.POST,
      data,
    }),
    UPDATE_WITHOUT_MASTER: (apiMidpoint: string, data: any) => ({
      url: `/master/${apiMidpoint}/update`,
      method: CONSTANTS.HTTP_METHOD.PUT,
      data,
    }),
  },
  SYSTEM_CONFIGURATION_CRUD: {
    LIST: (data: string) =>
      ({
        url: '/system-configurations/list' + '?' + data,
        method: 'get',
        data: {},
      }) as ViewMastersAPIDefinition,
    UPDATE: (data: any) => ({
      url: '/system-configurations/update',
      method: CONSTANTS.HTTP_METHOD.PUT,
      data,
    }),
    CREATE: (data: any) => ({
      url: '/system-configurations/add',
      method: CONSTANTS.HTTP_METHOD.POST,
      data,
    }),
  },
  LAYOUT_CONFIGURATION_CRUE: {
    LIST: (data: string, module: string) =>
      ({
        url: '/layout/list' + '?' + data + '&module=' + module,
        method: CONSTANTS.HTTP_METHOD.GET,
        data: {},
      }) as ViewMastersAPIDefinition,
    UPDATE: (data: any) => ({
      url: '/layout/update',
      method: CONSTANTS.HTTP_METHOD.PUT,
      data,
    }),
    CREATE: (data: any) => ({
      url: '/layout/add',
      method: CONSTANTS.HTTP_METHOD.POST,
      data,
    }),
  },
  Layout: ({ item, list }: { item: string; list?: string }) => {
    const url = list
      ? `/config/${item}Layout?type=${list}`
      : item === 'widget'
      ? `/config/${item}Layout?excludeSiteNavigationLayouts=true`
      : `/config/${item}Layout`

    return {
      url,
      method: CONSTANTS.HTTP_METHOD.GET,
      data: {},
    }
  },
}

export const CONTAINER_DEFINITION_CRUD = {
  LISTING: (data: string) =>
    ({
      url: '/container-definition/list' + '?' + data,
      method: CONSTANTS.HTTP_METHOD.GET,
      data: {},
    }) as any,
  TOLLGATES_LISTING: (data: string) =>
    ({
      url: '/system-configurations/list' + '?' + data,
      method: CONSTANTS.HTTP_METHOD.GET,
      data: {},
    }) as any,
  PARAMETER_LISTING: (data: string) =>
    ({
      url: '/parameter-repository/list' + '?' + data,
      method: 'get',
      data: CONSTANTS.HTTP_METHOD.GET,
    }) as any,
  CREATE: (data: any) => ({
    url: '/container-definition/add',
    method: CONSTANTS.HTTP_METHOD.POST,
    data,
  }),
  UPDATE: (data: any) => ({
    url: '/container-definition/update',
    method: CONSTANTS.HTTP_METHOD.PATCH,
    data,
  }),
  GET: (data: any) => ({
    url: '/container-definition/detail/' + data,
    method: CONSTANTS.HTTP_METHOD.GET,
    data: {},
  }),
  UPDATE_STATUS: (data: any) => ({
    url: '/container-definition/updateStatus',
    method: CONSTANTS.HTTP_METHOD.PATCH,
    data,
  }),
  INHERIT_CONTAINER: (data: any) => ({
    url: '/container/inheritContainer',
    method: CONSTANTS.HTTP_METHOD.POST,
    data,
  }),
  VALIDATE_ASSETS: (data: any) => ({
    url: '/container/validateAssetTypes',
    method: CONSTANTS.HTTP_METHOD.POST,
    data,
  }),
}

export const WIDGET_DEFINITION_CRUD = {
  LISTING: (data: string) =>
    ({
      url: '/widget-definition/list' + '?' + data,
      method: CONSTANTS.HTTP_METHOD.GET,
      data: {},
    }) as any,
  TOLLGATES_LISTING: (data: string) =>
    ({
      url: '/system-configurations/list' + '?' + data,
      method: CONSTANTS.HTTP_METHOD.GET,
      data: {},
    }) as any,
  PARAMETER_LISTING: (data: string) =>
    ({
      url: '/parameter-repository/list' + '?' + data,
      method: 'get',
      data: CONSTANTS.HTTP_METHOD.GET,
    }) as any,
  PARAMETER_SEARCH: (data: {
    module: ParameterModule
    parameterId: string
    definitionId: string
  }) =>
    ({
      url: '/common/getParameterInDefinition',
      method: CONSTANTS.HTTP_METHOD.POST,
      data,
    }) as any,
  CREATE: (data: any) => ({
    url: '/widget-definition/add',
    method: CONSTANTS.HTTP_METHOD.POST,
    data,
  }),
  UPDATE: (data: any) => ({
    url: '/widget-definition/update',
    method: CONSTANTS.HTTP_METHOD.PATCH,
    data,
  }),
  GET: (data: any) => ({
    url: '/widget-definition/detail/' + data,
    method: CONSTANTS.HTTP_METHOD.GET,
    data: {},
  }),
  UPDATE_STATUS: (data: any) => ({
    url: '/widget-definition/updateStatus',
    method: CONSTANTS.HTTP_METHOD.PATCH,
    data,
  }),
  VALIDAION_LISTING: () =>
    ({
      url: '/validation/list',
      method: CONSTANTS.HTTP_METHOD.GET,
      data: {},
    }) as any,
}

export const COUNTRIES_CRUD = {
  LIST_COUNTRY: (data: string) =>
    ({
      url: '/master/country/list' + '?' + data,
      method: 'get',
      data: {},
    }) as viewRoleAPIDefinationModal,
}

export const PLATFORM_LIST = {
  PLATFORM_LIST: (data: string) =>
    ({
      url: '/master/platform/list' + '?' + data,
      method: 'get',
      data: {},
    }) as viewRoleAPIDefinationModal,
}

export const CLUSTER_CRUD = {
  LIST_CLUSTER: (data: string) =>
    ({
      url: '/master/cluster/list' + '?' + data,
      method: 'get',
      data: {},
    }) as viewRoleAPIDefinationModal,
}

export const PACK_INFO = {
  LIST_PACK: (data: string) =>
    ({
      url: '/master/pack/list' + '?' + data,
      method: 'get',
      data: {},
    }) as viewRoleAPIDefinationModal,
}

export const PLATFORM_CRUD = {
  LIST_PLATFORM: (data: string) =>
    ({
      url: '/master/platform/list' + '?' + data,
      method: 'get',
      data: {},
    }) as viewRoleAPIDefinationModal,
}

export const STATE_CRUD = {
  LIST_STATE: (data: string) =>
    ({
      url: '/master/state/list' + '?' + data,
      method: 'get',
      data: {},
    }) as viewRoleAPIDefinationModal,
}

export const AB_SEGMENT = {
  LIST_AB_SEGMENT: (data: string) =>
    ({
      url: '/master/ab-segment/list' + '?' + data,
      method: 'get',
      data: {},
    }) as viewRoleAPIDefinationModal,
}

export const PUBLISHING_SEGMENT_CRUD = {
  LIST_PUBLISHING_SEGMENT: (data: string) =>
    ({
      url: '/master/publishing-segment/list' + '?' + data,
      method: 'get',
      data: {},
    }) as viewRoleAPIDefinationModal,
}

export const WIDGET_MANAGEMENT_CRUD = {
  LAYOUT: {
    LIST: (query: string) =>
      ({
        url: `/config/widgetLayout?${query}`,
        method: 'get',
        data: {},
      }) as viewRoleAPIDefinationModal,
  },
  IMAGE_UPLOAD: (data: any) =>
    ({
      url: '/widget/image',
      method: CONSTANTS.HTTP_METHOD.PATCH,
      data: data,
    }) as WidgetCRUDAPIDefinitionModal,
  LISTING: (data: any) =>
    ({
      url: '/widget/list',
      method: CONSTANTS.HTTP_METHOD.POST,
      data,
    }) as any,
  ADD: (data: any) =>
    ({
      url: '/widget/add',
      method: CONSTANTS.HTTP_METHOD.POST,
      data: data,
    }) as WidgetCRUDAPIDefinitionModal,
  UPDATE: (data: any) =>
    ({
      url: '/widget/update',
      method: CONSTANTS.HTTP_METHOD.PATCH,
      data: data,
      validate: true,
    }) as WidgetCRUDAPIDefinitionModal,
  ASSET_LISTING: (data: any) =>
    ({
      url: '/widget/assets',
      method: CONSTANTS.HTTP_METHOD.POST,
      data: data,
    }) as WidgetCRUDAPIDefinitionModal,
  TYPES_LISTING: () =>
    ({
      url: '/widget/types',
      method: 'get',
      data: {},
    }) as WidgetCRUDAPIDefinitionModal,
  LAYOUTS_LISTING: (widgetType: string) =>
    ({
      url: '/widget/layouts?' + widgetType,
      method: 'get',
      data: {},
    }) as WidgetCRUDAPIDefinitionModal,

  GET_ASSETS_DETAIL_BY_IDS: (ids: string[]) =>
    ({
      url: '/widget/assetMetadata?contentIds=' + ids?.join('%2C'),
      method: 'get',
      data: {},
    }) as WidgetCRUDAPIDefinitionModal,
  GET_WIDGET_DEFINITION_BY_ID: (id: string) =>
    ({
      url: `/widget/widget-definition/${id}`,
      method: 'get',
      data: {},
    }) as WidgetCRUDAPIDefinitionModal,
  GET_WIDGET_DETAILS_BY_ID: (id: string) =>
    ({
      url: `/widget/detail/${id}`,
      method: 'get',
      data: {},
    }) as WidgetCRUDAPIDefinitionModal,
  GET_WIDGET_AUTOMATED_LISTS: (data: any) =>
    ({
      url: '/widget/automatedassets',
      method: CONSTANTS.HTTP_METHOD.POST,
      data,
    }) as WidgetCRUDAPIDefinitionModal,
  AUTOMATTED_ADD: (data: any) =>
    ({
      url: '/widget/automatedassets',
      method: CONSTANTS.HTTP_METHOD.POST,
      data: data,
    }) as any,
  WIDGET_AUTOMATTED_ADD: (data: any) =>
    ({
      url: '/widget/add',
      method: CONSTANTS.HTTP_METHOD.POST,
      data: data,
    }) as any,
  WIDGET_AUTOMATTED_UPDATE: (data: any) =>
    ({
      url: '/widget/update',
      method: CONSTANTS.HTTP_METHOD.PATCH,
      data: data,
      validate: true,
    }) as any,
  MARK_AS_DONE: (data: any) =>
    ({
      url: '/widget/markDone',
      method: CONSTANTS.HTTP_METHOD.PATCH,
      data,
    }) as any,
  WIDGET_FEATURE: (data: any) =>
    ({
      url: '/widget/feature',
      method: CONSTANTS.HTTP_METHOD.PATCH,
      data: data,
    }) as any,
  WIDGET_UNFEATURE: (data: any) =>
    ({
      url: '/widget/unfeature',
      method: CONSTANTS.HTTP_METHOD.PATCH,
      data: data,
    }) as any,
  CONTENT_METADATA: (data: any) =>
    ({
      url: '/widget/contentmetadata',
      method: CONSTANTS.HTTP_METHOD.POST,
      data: data,
    }) as any,

  WIDGET_IMAGES_LIST: (widgetId: any, widgetState: any) =>
    ({
      url: `/widget/images?widgetId=${widgetId}&state=${widgetState}`,
      method: CONSTANTS.HTTP_METHOD.GET,
      data: {},
    }) as any,
  VERSION_LIST: (data: any) =>
    ({
      url: '/widget/versions',
      method: CONSTANTS.HTTP_METHOD.POST,
      data: data,
    }) as any,
  CHECK_DRAFT_VERSION: (id: string, widgetId: string) =>
    ({
      url: `/widget/checkDraftVersion/${id}/${widgetId}`,
      method: 'get',
      data: {},
    }) as any,
  CREATE_VERSION: (id: string) =>
    ({
      url: `/widget/createVersion/${id}`,
      method: 'get',
      data: {},
    }) as any,
  CHECK_DEPUBLISHED: (data: any) =>
    ({
      url: '/widget/unFeatureAssetDetails',
      method: CONSTANTS.HTTP_METHOD.POST,
      data: data,
    }) as any,
  WIDGET_DELETE: (id: any) =>
    ({
      url: '/widget/delete/' + id,
      method: CONSTANTS.HTTP_METHOD.DELETE,
      data: {},
    }) as any,
}

export const CONTAINER_MANAGEMENT_CRUD = {
  LAYOUT: {
    LIST: (query: string) =>
      ({
        url: `/config/containerLayout?${query}`,
        method: CONSTANTS.HTTP_METHOD.GET,
        data: {},
      }) as any,
  },
  WIDGET_META: (ids: string[]) =>
    ({
      url: '/widget/metadata?widgetIds=' + ids.join('%2C'),
      method: CONSTANTS.HTTP_METHOD.GET,
      data: {},
    }) as any,
  LISTING: (data: any) =>
    ({
      url: '/container/list',
      method: CONSTANTS.HTTP_METHOD.POST,
      data,
    }) as any,
  CHILD_LISTING: (data: any) =>
    ({
      url: '/container/contentList',
      method: CONSTANTS.HTTP_METHOD.POST,
      data,
    }) as any,
  TYPES: () =>
    ({
      url: '/container/types',
      method: 'get',
      data: {},
    }) as any,
  LAYOUTS: (types: string) =>
    ({
      url: '/container/layouts?' + types,
      method: 'get',
      data: {},
    }) as WidgetCRUDAPIDefinitionModal,
  GET_CONTAINER_DEFINITION_DETAIL_BY_ID: (id: string) =>
    ({
      url: `/container/definition/${id}`,
      method: CONSTANTS.HTTP_METHOD.GET,
      data: {},
    }) as WidgetCRUDAPIDefinitionModal,
  GET_CONTAINER_DETAIL_BY_ID: (id: string) =>
    ({
      url: `/container/detail/${id}`,
      method: CONSTANTS.HTTP_METHOD.GET,
      data: {},
    }) as WidgetCRUDAPIDefinitionModal,
  ADD: (data: any) =>
    ({
      url: '/container/add',
      method: CONSTANTS.HTTP_METHOD.POST,
      data: data,
    }) as WidgetCRUDAPIDefinitionModal,
  UPDATE: (data: any) =>
    ({
      url: '/container/update',
      method: CONSTANTS.HTTP_METHOD.PATCH,
      data: data,
      validate: true,
    }) as WidgetCRUDAPIDefinitionModal,
  IMAGE_UPLOAD: (data: any) =>
    ({
      url: '/container/image',
      method: CONSTANTS.HTTP_METHOD.PATCH,
      data: data,
    }) as WidgetCRUDAPIDefinitionModal,
  MARK_AS_DONE: (data: any) =>
    ({
      url: '/container/markDone',
      method: CONSTANTS.HTTP_METHOD.PATCH,
      data,
    }) as any,
  CONTAINER_FEATURE: (data: any) =>
    ({
      url: '/container/feature',
      method: CONSTANTS.HTTP_METHOD.PATCH,
      data: data,
    }) as any,
  CONTAINER_UNFEATURE: (data: any) =>
    ({
      url: '/container/unfeature',
      method: CONSTANTS.HTTP_METHOD.PATCH,
      data: data,
    }) as any,
  CONTAINER_DELETE: (id: any) =>
    ({
      url: '/container/delete/' + id,
      method: CONSTANTS.HTTP_METHOD.DELETE,
      data: {},
    }) as any,
  VERSION_LIST: (data: any) =>
    ({
      url: '/container/versions',
      method: CONSTANTS.HTTP_METHOD.POST,
      data: data,
    }) as any,
  CHECK_DRAFT_VERSION: (id: string, containerId: string) =>
    ({
      url: `/container/checkDraftVersion/${id}/${containerId}`,
      method: 'get',
      data: {},
    }) as any,
  CREATE_VERSION: (id: string) =>
    ({
      url: `/container/createVersion/${id}`,
      method: 'get',
      data: {},
    }) as any,
  CHECK_DEPUBLISHED_WIDGET: (data: any) =>
    ({
      url: '/container/unFeatureWidgetDetails',
      method: CONSTANTS.HTTP_METHOD.POST,
      data: data,
    }) as any,
}

export const BLITZ_MASTER_CRUD = {
  LISTING: (key: string) =>
    ({
      url: `/blitz-master/list?keyName=${key}`,
      method: CONSTANTS.HTTP_METHOD.GET,
      data: {},
    }) as any,
}

export const CATEGORY_CRUD = {
  LISTING: (data: { contentCategoryValue: string[]; assetCategoryValue: string[] }) =>
    ({
      url: '/category/list',
      method: CONSTANTS.HTTP_METHOD.POST,
      data,
    }) as any,
}

export const ASSETS_CRUD = {
  GENERATE_PRESIGNED_URL: (type: string, key: string) =>
    ({
      url: `/${type}/pre-signed-url?key=${key}`,
      method: CONSTANTS.HTTP_METHOD.GET,
      data: {},
    }) as any,
}

export const SITE_NAVIGATION_CRUD = {
  LAYOUT: {
    LIST: () =>
      ({
        url: '/config/widgetLayout',
        method: CONSTANTS.HTTP_METHOD.GET,
        data: {},
      }) as any,
  },
  LISTING: (data: any) =>
    ({
      url: '/site-navigation/list',
      method: CONSTANTS.HTTP_METHOD.POST,
      data,
    }) as any,
  TYPES_LISTING: () =>
    ({
      url: '/site-navigation/types',
      method: 'get',
      data: {},
    }) as WidgetCRUDAPIDefinitionModal,
  LAYOUTS_LISTING: (widgetType: string) =>
    ({
      url: '/site-navigation/layouts?' + widgetType,
      method: 'get',
      data: {},
    }) as WidgetCRUDAPIDefinitionModal,
  ADD: (data: any) =>
    ({
      url: '/site-navigation/add',
      method: CONSTANTS.HTTP_METHOD.POST,
      data: data,
    }) as WidgetCRUDAPIDefinitionModal,
  UPDATE: (data: any) =>
    ({
      url: '/site-navigation/update',
      method: CONSTANTS.HTTP_METHOD.PATCH,
      data: data,
      validate: true,
    }) as WidgetCRUDAPIDefinitionModal,
  GET_DETAIL_BY_ID: (id: string) =>
    ({
      url: `/site-navigation/detail/${id}`,
      method: CONSTANTS.HTTP_METHOD.GET,
      data: {},
    }) as WidgetCRUDAPIDefinitionModal,
  MARK_AS_DONE: (data: any) =>
    ({
      url: '/site-navigation/markDone',
      method: CONSTANTS.HTTP_METHOD.PATCH,
      data,
    }) as any,
  FEATURE: (data: any) =>
    ({
      url: '/site-navigation/feature',
      method: CONSTANTS.HTTP_METHOD.PATCH,
      data: data,
    }) as any,
  UNFEATURE: (data: any) =>
    ({
      url: '/site-navigation/unfeature',
      method: CONSTANTS.HTTP_METHOD.PATCH,
      data: data,
    }) as any,
  VERSION_LIST: (data: any) =>
    ({
      url: '/site-navigation/versions',
      method: CONSTANTS.HTTP_METHOD.POST,
      data: data,
    }) as any,
  CHECK_DRAFT_VERSION: (id: string, siteNavigationId: string) =>
    ({
      url: `/site-navigation/checkDraftVersion/${id}/${siteNavigationId}`,
      method: 'get',
      data: {},
    }) as any,
  CREATE_VERSION: (id: string) =>
    ({
      url: `/site-navigation/createVersion/${id}`,
      method: 'get',
      data: {},
    }) as any,
  WIDGET_DELETE: (id: any) =>
    ({
      url: '/site-navigation/delete/' + id,
      method: CONSTANTS.HTTP_METHOD.DELETE,
      data: {},
    }) as any,
}
export const AUDIT_LOGS = {
  ITEM_LOG_LIST: (data: any) =>
    ({
      baseUrl: CONSTANTS.AUDIT_LOGS_BASE_URL,
      url: '/audit-trails/list',
      method: CONSTANTS.HTTP_METHOD.POST,
      data,
    }) as any,
  VIEW: (id: string) =>
    ({
      baseUrl: CONSTANTS.AUDIT_LOGS_BASE_URL,
      url: `/audit-trails/detail/${id}`,
      method: CONSTANTS.HTTP_METHOD.GET,
      data: {},
    }) as any,
  FEATURED: (contentId: string) =>
    ({
      baseUrl: CONSTANTS.AUDIT_LOGS_BASE_URL,
      url: `/audit-trails/list?event=Feature&state=featured&contentId=${contentId}`,
      method: CONSTANTS.HTTP_METHOD.GET,
      data: {},
    }) as any,
  CONTENT_STATUS: (data: any) =>
    ({
      baseUrl: CONSTANTS.AUDIT_LOGS_BASE_URL,
      url: '/audit-trails/getContentStatus',
      method: CONSTANTS.HTTP_METHOD.POST,
      data: data,
    }) as any,
}
export const SCHEDULE_CRUD = {
  SCHEDULE_ADD: (data: any) =>
    ({
      url: '/schedule/add',
      method: CONSTANTS.HTTP_METHOD.POST,
      data,
    }) as any,
  SCHEDULE_UPDATE: (data: any) =>
    ({
      url: '/schedule/update',
      method: CONSTANTS.HTTP_METHOD.PATCH,
      data,
    }) as any,
  SCHEDULE_DRAFT_VERSION: (id: string, containerId: string) =>
    ({
      url: `/container/checkDraftForScheduledVersion/${id}/${containerId}`,
      method: CONSTANTS.HTTP_METHOD.GET,
    }) as any,
  SCHEDULE_DRAFT_VERSION_WIDGET: (id: string, containerId: string) =>
    ({
      url: `/widget/checkDraftForScheduledVersion/${id}/${containerId}`,
      method: CONSTANTS.HTTP_METHOD.GET,
    }) as any,
  SCHEDULE_DRAFT_VERSION_SITE_NAVIGATION: (id: string, siteNavigationId: string) =>
    ({
      url: `/site-navigation/checkDraftForScheduledVersion/${id}/${siteNavigationId}`,
      method: CONSTANTS.HTTP_METHOD.GET,
    }) as any,
  SCHEDULE_CHECK_VERSION: (data: any) =>
    ({
      url: '/schedule/checkScheduledVersion',
      method: CONSTANTS.HTTP_METHOD.POST,
      data,
    }) as any,

  DELETE_SCHEDULE: (id: string) =>
    ({
      url: `/schedule/delete/${id}`,
      method: CONSTANTS.HTTP_METHOD.DELETE,
    }) as any,
}

export const OVER_RIDE_IMAGE = {
  API_ENDPOINT: '/config/imageNodeList',
  IMAGE_NODE_LIST: () => ({
    url: '/config/imageNodeList',
    method: 'get',
    data: {},
  }),
  IMAGE_NODES_LIST_DEFINITION: (definitionId: string) => ({
    url: `/widget/imageNodes/${definitionId}`,
    method: 'get',
    data: {},
  }),
  UPDATE: (data: any) =>
    ({
      url: '/widget/overrideImage',
      method: CONSTANTS.HTTP_METHOD.PATCH,
      data: data,
    }) as WidgetCRUDAPIDefinitionModal,
  DETAILS: (widgetId: string, contentId: string) =>
    ({
      url: `/widget/imageOverrideDetail/${widgetId}/${contentId}`,
      method: CONSTANTS.HTTP_METHOD.GET,
      data: {},
    }) as any,
}

export const ADVANCE_SEARCH = {
  LIST_ITEMS: () => ({
    url: '/system-configurations/list?keyName=MODULE',
    method: CONSTANTS.HTTP_METHOD.GET,
    data: {},
  }),
  LIST: ({ item }: { item: string }) => ({
    url:
      item === 'widget'
        ? `/config/${item}Layout?excludeSiteNavigationLayouts=true`
        : `/config/${item}Layout`,
    method: CONSTANTS.HTTP_METHOD.GET,
    data: {},
  }),
  Layout: ({ item, list }: { item: string; list?: string }) => {
    const url = list
      ? `/config/${item}Layout?type=${list}`
      : item === 'widget'
      ? `/config/${item}Layout?excludeSiteNavigationLayouts=true`
      : `/config/${item}Layout`

    return {
      url,
      method: CONSTANTS.HTTP_METHOD.GET,
      data: {},
    }
  },
  ADVANCE_SEARCH_STATE: (key: string) => ({
    url: '/system-configurations/list?keyName=' + key,
    method: CONSTANTS.HTTP_METHOD.GET,
    data: {},
  }),
  ADVANCE_SEARCH_RESULT: (data: any) => ({
    url: '/global-search/list',
    method: CONSTANTS.HTTP_METHOD.POST,
    data: data,
  }),
  ADVANCE_SEARCH_SAVE: (data: any) => ({
    url: '/save-search/add',
    method: CONSTANTS.HTTP_METHOD.POST,
    data: data,
  }),
  SAVED_SEARCH_LIST: (data: string) =>
    ({
      url: `/save-search/list${data ? `?${data}` : ''}`,
      method: CONSTANTS.HTTP_METHOD.GET,
      data: {},
    }) as viewRoleAPIDefinationModal,
  DELETE_SAVED_SEARCH: (id: string) =>
    ({
      url: `/save-search/delete/${id}`,
      method: CONSTANTS.HTTP_METHOD.DELETE,
    }) as any,
  UPDATE_SAVED_SEARCH: (data: any) =>
    ({
      url: '/save-search/update',
      method: CONSTANTS.HTTP_METHOD.PATCH,
      data: data,
    }) as WidgetCRUDAPIDefinitionModal,
  PIN_SAVED_SEARCH_COUNT: () =>
    ({
      url: '/save-search/pinnedCount',
      method: CONSTANTS.HTTP_METHOD.GET,
      data: {},
    }) as viewRoleAPIDefinationModal,
  FORM_DETAIL: (id: any) => ({
    url: `/save-search/detail/${id}`,
    method: CONSTANTS.HTTP_METHOD.GET,
    data: {},
  }),
  MODULE_STATE_LIST: (data: any) => ({
    url: `/global-search/moduleStates/${data}`,
    method: CONSTANTS.HTTP_METHOD.GET,
    data: {},
  }),
}

export const MANAGE_TIPS = {
  TIPS_LIST: (data: any) =>
    ({
      url: '/tool-tip/list' + '?' + data,
      method: CONSTANTS.HTTP_METHOD.GET,
      data: {},
    }) as any,
  TIPS_ADD: (data: any) =>
    ({
      url: '/tool-tip/add',
      method: CONSTANTS.HTTP_METHOD.POST,
      data: data,
    }) as any,
  TIPS_UPDATE: (data: any) =>
    ({
      url: '/tool-tip/update',
      method: CONSTANTS.HTTP_METHOD.PUT,
      data: data,
    }) as any,
  TIPS_DETAIL: (key: any) =>
    ({
      url: '/tool-tip/detail/' + key,
      method: CONSTANTS.HTTP_METHOD.GET,
      data: {},
    }) as any,
  TIPS_DELETE: (key: any) =>
    ({
      url: '/tool-tip/delete/' + key,
      method: CONSTANTS.HTTP_METHOD.DELETE,
      data: {},
    }) as any,
  MODULE_PAGES: (key: any) =>
    ({
      url: '/tool-tip/modulePageMappingList?keyName=' + key,
      method: CONSTANTS.HTTP_METHOD.GET,
      data: {},
    }) as any,
}

export const ASSOCIATED_LIST = {
  LISTING: (data: any) =>
    ({
      url: '/global-search/associatedContent',
      method: CONSTANTS.HTTP_METHOD.POST,
      data: data,
    }) as any,
  ASSOCIATED_PARAMETER_LISTING: (data: any) =>
    ({
      url: '/global-search/associatedDefinitions',
      method: CONSTANTS.HTTP_METHOD.POST,
      data: data,
    }) as any,

  CHECK_ASSOCIATED_CONTENT: (module: string, contentMongoId: string) => ({
    url: `/common/associatedContent?module=${module}&moduleDocId=${contentMongoId}`,
    method: CONSTANTS.HTTP_METHOD.GET,
    data: {},
  }),
}

export const LISTING_PREFERENCES = {
  LISTING_PARAMETERS: (key: any) => ({
    url: '/user-configuration/getParameterList?module=' + key,
    method: CONSTANTS.HTTP_METHOD.GET,
    data: {},
  }),
  UPDATE_USER_LISTING_PREERENCES: (data: any) => ({
    url: '/user-configuration/update',
    method: CONSTANTS.HTTP_METHOD.PATCH,
    data: data,
  }),
}

export const USER_CONFIGURATION = {
  GET_LISTING_CONFI: () =>
    ({
      url: '/user-configuration/list',
      method: CONSTANTS.HTTP_METHOD.GET,
      data: {},
    }) as any,
}

export const MULTIUSER_LOCKING = {
  GET_LOCKSTATUS: (data: { contentId: number; module: string; contentDocId: string }) => ({
    url: '/common/lockStatus',
    method: CONSTANTS.HTTP_METHOD.POST,
    data,
  }),
  LOCK_USER: (data: { contentId: number; module: string; contentDocId: string }) => ({
    url: '/common/lockUser',
    method: CONSTANTS.HTTP_METHOD.POST,
    data,
  }),
  LOCK_CHANGE: (data: { contentId: number; module: string; contentDocId: string }) => ({
    url: '/common/hasLockChanged',
    method: CONSTANTS.HTTP_METHOD.POST,
    data,
  }),
  UNLOCK_USER: (data: { contentId: number; module: string; contentDocId: string }) => ({
    url: '/common/unlockUser',
    method: CONSTANTS.HTTP_METHOD.POST,
    data,
  }),
}

export const BULK_OPERATIONS = {
  BULK_STATE_CHANGE_LIST: (data: any) =>
    ({
      url: '/job/list',
      method: CONSTANTS.HTTP_METHOD.POST,
      data: data,
    }) as any,
  BULK_STATE_CHANGE_CREATE: (data: any) =>
    ({
      url: '/job/add',
      method: CONSTANTS.HTTP_METHOD.POST,
      data: data,
    }) as any,
  BULK_STATE_CHANGE_REPORT: (data: any) =>
    ({
      url: `/job/download?jobId=${data}`,
      method: CONSTANTS.HTTP_METHOD.GET,
      data: {},
    }) as any,
  CSV_BULK_UPLOAD_CREATE: (data: any) =>
    ({
      url: '/job/createBulkCsvUpload',
      method: CONSTANTS.HTTP_METHOD.POST,
      data: data,
    }) as any,
  CSV_BULK_UPLOAD_UPDATE: (data: any) =>
    ({
      url: '/job/jobDetailUpdate',
      method: CONSTANTS.HTTP_METHOD.PATCH,
      data: data,
    }) as any,
  CSV_BULK_UPLOAD_CANCEL: (data: any) =>
    ({
      url: '/job/cancel',
      method: PATCH,
      data: data,
    }) as any,
  SAMPLE_CSV_DOWNLOAD: () =>
    ({
      url: '/job/downloadSampleFile',
      method: CONSTANTS.HTTP_METHOD.GET,
      data: {},
    }) as any,
}

export const ADDITIONAL_PARAMETER_API = {
  GET_DETAIL: (itemType: string, detailId: string, contentType: moduleType, itemId: string) =>
    ({
      url: `/common/${ADDITIONAL_PARAMETER}/${DETAIL}?module=${itemType}&moduleDocId=${detailId}&contentType=${contentType}&contentId=${itemId}`,
      method: GET,
      data: {},
    }) as any,
  UPDATE: (data: any) => ({
    url: `/common/${ADDITIONAL_PARAMETER}/${UPDATE}`,
    method: PATCH,
    data: data,
  }),
  IMAGE_UPLOAD: (data: any) =>
    ({
      url: `/common/${ADDITIONAL_PARAMETER}/image`,
      method: CONSTANTS.HTTP_METHOD.PATCH,
      data: data,
    }) as any,
}

export const NOTIFICATIONS = {
  NOTIFICATIONS_EVENT: () =>
    ({
      url: '/user-configuration/notificationPreference',
      method: CONSTANTS.HTTP_METHOD.GET,
      data: {},
    }) as any,
  USER_CONFIGURATION: (data: any) =>
    ({
      url: '/user-configuration/update',
      method: CONSTANTS.HTTP_METHOD.PATCH,
      data: data,
    }) as any,
  NOTIFICATION_COUNT: () =>
    ({
      baseUrl: CONSTANTS.NOTIFICATION_BASE_URL,
      url: '/notification/unseenCount',
      method: CONSTANTS.HTTP_METHOD.GET,
      data: {},
    }) as any,
  NOTIFICATION_MARK_AS_SEEN: () =>
    ({
      baseUrl: CONSTANTS.NOTIFICATION_BASE_URL,
      url: '/notification/markAllAsSeen',
      method: CONSTANTS.HTTP_METHOD.PATCH,
      data: {},
    }) as any,
  NOTIFICATION_LIST: (data: any) =>
    ({
      baseUrl: CONSTANTS.NOTIFICATION_BASE_URL,
      url: '/notification/list',
      method: CONSTANTS.HTTP_METHOD.POST,
      data: data,
    }) as any,
  NOTIFICATION_MARK_AS_READ: (data: any) =>
    ({
      baseUrl: CONSTANTS.NOTIFICATION_BASE_URL,
      url: '/notification/markAsRead',
      method: CONSTANTS.HTTP_METHOD.PATCH,
      data: data,
    }) as any,
  NOTIFICATION_EVENTS: () =>
    ({
      url: '/user-configuration/notificationEvents',
      method: CONSTANTS.HTTP_METHOD.GET,
    }) as any,
}
export const REVOKE_ACCESS_API = {
  LIST: (data: any) =>
    ({
      url: '/access-window/list',
      method: CONSTANTS.HTTP_METHOD.POST,
      data: data,
    }) as any,
  CREATE: (data: any) => ({
    url: '/access-window/add',
    method: CONSTANTS.HTTP_METHOD.POST,
    data: data,
  }),
  UPDATE: (data: any) => ({
    url: '/access-window/update',
    method: CONSTANTS.HTTP_METHOD.PATCH,
    data: data,
  }),
  DELETE: (id: string) => ({
    url: `/access-window/delete/${id}`,
    method: CONSTANTS.HTTP_METHOD.DELETE,
    data: {},
  }),
  DETAIL: (id: string) => ({
    url: `/access-window/detail/${id}`,
    method: CONSTANTS.HTTP_METHOD.GET,
    data: {},
  }),
  CHECK_ACTIVE_WINDOW: (data: any) => ({
    url: `/access-window/checkActiveWindow/${data}`,
    method: CONSTANTS.HTTP_METHOD.GET,
    data: {},
  }),
}

export const SYSTEM_SETTINGS = {
  GET_STATUS: () =>
    ({
      url: '/system-settings/getStatus',
      method: CONSTANTS.HTTP_METHOD.GET,
      data: {},
    }) as any,
  UPDATE_STATUS: (data: { settingId: string; settingValue: boolean }) =>
    ({
      url: '/system-settings/status',
      method: CONSTANTS.HTTP_METHOD.PATCH,
      data: data,
    }) as any,
}
